export const dataMerger = (valueLeft, valueRight) =>
  Array.isArray(valueLeft) ? valueRight : undefined
